// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "styles" + "." + "0305128c93c912e4778d" + ".css";
};